import React from 'react'

const Textarea = (props) => {
    const { label, ...rest } = props
    return (
        <div className='mb-3'>
            <label className='block mb-1'>{label} </label>
            <textarea className='border px-2 py-1 w-full outline-purple-800 shadow-md rounded-md' {...rest} />
        </div>
    )
}

export default Textarea